"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Page = _interopRequireDefault(require("./pages/Page"));

var _ProgramPage = _interopRequireDefault(require("./programs/ProgramPage"));

var _PostPurchaseProgramRecommendations = _interopRequireDefault(require("./PostPurchaseProgramRecommendations/containers/PostPurchaseProgramRecommendations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  Page: _Page["default"],
  ProgramPage: _ProgramPage["default"],
  PostPurchaseProgramRecommendations: _PostPurchaseProgramRecommendations["default"]
};
exports["default"] = _default;